import React from 'react'

function Loading() {
    return (
        <div className="loading-spinner text danger"
        style={{height: "50", width: "50"}}>
            
        </div>
    )
}

export default Loading;
